// extracted by mini-css-extract-plugin
module.exports = {"w824tl4":"w824tl4"};